
import React from 'react'
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";

const Obligations = ({obligations}) => {
  return (
    <div className="my-12">
    <h2 className=" uppercase letter-spacing  font-semibold text-gray-800 mt-5">
      Obligations{" "}
    </h2>
    <hr />
    <div className="mt-8 flex flex-col">
      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table className="min-w-full table-fixed divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                  >
                    Narration
                  </th>
                  <th
                    scope="col"
                    className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {obligations?.map((person) => (
                  <tr className="bg-gray-50">
                    <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                      {person?.naration}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                      {FormatMoney(person?.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Obligations



